const PageGallery = () => {
  return (
    <main className="gallery">
      <section className="rest">
        <span className="img-whale" />
      </section>
    </main>
  );
};

export default PageGallery;
